<div class="b-f-stepper">
  <basin-stepper
    [(stepsActiveIndex)]="props.activeIndex"
    [readonly]="props.readonly"
    [style]="props.style"
    [styleClass]="props.styleClass"
    [stepsTracker]="props.stepsTracker"
    [stepItems]="props.items"
  ></basin-stepper>
  <div class="b-f-stepper-step">
    <div
      class="b-f-stepper-step-form"
      *ngFor="let step of field.fieldGroup; let i = index"
    >
      <p-card
        class="b-f-stepper-step-card basin-shadow"
        *ngIf="i === props.activeIndex"
      >
        <div *ngIf="step.props.comingSoon" class="basin-card-bookmark">
          <p>Coming Soon!</p>
        </div>
        <ng-template pTemplate="content">
          <formly-field [field]="step"></formly-field>
        </ng-template>
        <ng-template pTemplate="footer"
          ><button
            pButton
            type="button"
            (click)="props.onCancel($event)"
            class="p-button-text b-f-stepper-cancel"
          >
            Cancel
          </button>
          <button
            *ngIf="props.deleteEnabled"
            pButton
            type="button"
            (click)="props.onDelete($event)"
            class="p-button-danger b-f-stepper-delete"
          >
            Delete
          </button>
          <button
            [disabled]="!form.valid"
            (click)="props.onSave($event)"
            pButton
            type="button"
            class="b-f-stepper-save"
          >
            Save
          </button></ng-template
        >
      </p-card>
    </div>
  </div>
</div>
